import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { getEmpresaSelecionada } from '../../util/empresaSelecionada'
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras'
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada';
import { isAmbienteDev } from '../../util/applicationContext';
import selecionarRota from '../../actions/rota/selecionarRota';
import limparItinerarios from '../../actions/itinerario/limparItinerarios'

export const firstLetter = nomeUsuario => (nomeUsuario ? nomeUsuario.charAt(0) : '');

export const secondLetter = (nomeUsuario) => {
  if (nomeUsuario) {
    const nomeSplited = nomeUsuario.split(' ');
    if (nomeSplited.length > 1) {
      return nomeSplited[1] ? nomeSplited[1].charAt(0) : ''
    }
  }
  return ''
};

export const recuperaEmpresaSelecionada = () => {
  const empresaSelecionada = getEmpresaSelecionada();
  return empresaSelecionada
};

export class BarraNavegacao extends Component {
  mudarAutacao () {
    this.props.alterarEmpresaSelecionada(null)
    this.props.selecionarRota([])
    this.props.limparItinerarios()
    this.props.history.push('/selecao-empresa')
  }

  exibirPerfilUsuario () {
    return <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop float-right">
      <li className="nav-item dropdown menu-usuario">
        <a href='#' id="icone-circular-sair" className="nav-link" data-toggle="dropdown" role="button"
           aria-haspopup="true" aria-expanded="false">
              <span className="img-avatar circle" style={{ cursor: 'pointer' }}>
                {this.props.siglaUsuario}
              </span>
        </a>
        <div className="dropdown-menu dropdown-menu-right">
          <div className="dropdown-header text-center">
            <strong>Perfil</strong>
          </div>
          <div className="dropdown-content">
            <a href='#' className="dropdown-item">
              {this.props.nomeUsuario}
            </a>
          </div>
          <div className="dropdown-content">
            <a href='#' className="dropdown-item"
               data-toggle="modal"
               data-target="#modalAlterarSenhaUsuario">
              <span>Alterar senha</span>
            </a>
          </div>
          {this.props.empresas && this.props.empresas.length > 1
            ? <div className="dropdown-content">
              <a href='#' className="dropdown-item" onClick={() => this.mudarAutacao()}>
                <span>Mudar empresa</span>
              </a>
            </div> : ''
          }
          <div className="dropdown-content">
            <Link id="item-sair" className="dropdown-item custom-itens-dd" to="/logout">
              <i className="material-icons">
                &#xe8ac;
              </i> <span>Sair</span>
            </Link>
          </div>
        </div>
      </li>
    </ul>
  }

  exibirImagemEmpresaSelecionada () {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      return (<div style={{
        position: 'relative',
        alignItems: 'center'
      }}>
        {isAmbienteDev() ? <p title={this.props.empresaSelecionada.nomeFantasia} style={{
            position: 'absolute',
            right: '100%'
          }}>{this.props.empresaSelecionada.nomeFantasia.length > 20 ? this.props.empresaSelecionada.nomeFantasia.substring(0, 19) + ' ...' : this.props.empresaSelecionada.nomeFantasia}</p> :
          <img id={`imagem-empresa-${this.props.empresaSelecionada.id}`} alt={this.props.empresaSelecionada.nomeFantasia} title={this.props.empresaSelecionada.nomeFantasia} style={{
            position: 'absolute',
            right: '100%',
            maxWidth: '100px',
            maxHeight: '50px',
            width: 'auto',
            height: 'auto'
          }}
               src={this.props.empresaSelecionada.urlImagem}/>}
      </div>)
    }
  }

  render () {
    return (
      <header className={`app-header navbar ${isAmbienteDev() ? 'navbar-dark bg-primary' : 'navbar-dark bg-dark'}`}>
          <ul className="nav">
            {this.props.history.location && this.props.history.location.pathname !== '/painel-vendas-geral' ?
              <Link className="nav-link" to="/">
                <i className="material-icons nav-icon"
                   style={{ fontSize: '30px', verticalAlign: 'middle', color: '#FFFFFF' }}>&#xe88a;</i>
              </Link>
              : ''
            }
          </ul>
          {isAmbienteDev() ?
          <h2 className='text-center'>
            DESENVOLVIMENTO
          </h2> : ''
        }
        <div>
          {this.exibirPerfilUsuario()}
          {this.exibirImagemEmpresaSelecionada()}
        </div>
      </header>
    )
  }
}

export function mapStateToProps ({ authentication: { nomeUsuario, empresas } }) {
  return {
    siglaUsuario: `${firstLetter(nomeUsuario)}${secondLetter(nomeUsuario)}`,
    nomeUsuario: capitalizarTodasPrimeirasLetras(nomeUsuario),
    empresas,
    empresaSelecionada: recuperaEmpresaSelecionada()
  }
}

export default withRouter(connect(mapStateToProps, { 
  alterarEmpresaSelecionada,
  selecionarRota,
  limparItinerarios
})(BarraNavegacao))
